import React from 'react';
import {
  Row, Col, Badge,
} from 'react-bootstrap';
import opportunities from 'assets/img/opportunities-bg.png';
import { ReactComponent as IconPin } from 'assets/icons/pin.svg';
import { ReactComponent as IconBell } from 'assets/icons/bell.svg';
import { FutureInvestment } from 'types/FutureInvestment';
import ButtonImInterested from '../ButtonImInterested';

function PromotionOverview( {
  futureInvestment,
  opportunityInterestsme,
}:{ futureInvestment: FutureInvestment,
  opportunityInterestsme: ( ) => void
} ) {
  const imageSrc = futureInvestment?.bigImageUrl?.trim()
    ? futureInvestment.bigImageUrl : opportunities;
  return (
    <div className="bg-image">
      <img src={imageSrc} alt="Oportunidades" />

      <div className="bg-image-content">
        <Row>
          <Col className="text-end">
            <Badge bg="outline-gray16" text="gray16">
              {futureInvestment.estadoVentas}
            </Badge>
          </Col>
        </Row>

        <Badge bg="outline-white" text="white">
          <IconBell />
          <span className="ms-2">{`Plazo: ${futureInvestment?.plazoIinversion || 0} meses`}</span>
        </Badge>

        <h1 className="title">
          {futureInvestment.provincia && (
          <>
            {futureInvestment.provincia}
            {' '}
            |
            {' '}
          </>
          )}
          {futureInvestment.codigoPromocion}
        </h1>

        <h5 className="subtitle">
          {futureInvestment?.tipoActivo}
          {( futureInvestment?.tipoActivo || futureInvestment?.direccion ) && (
          <IconPin className="mx-2" />
          )}
          {futureInvestment?.direccion}
        </h5>

        {!!futureInvestment.invitacionOportunidadId && (
        <ButtonImInterested opportunityInterestsme={opportunityInterestsme} />
        )}
      </div>
    </div>

  );
}

export default PromotionOverview;
